import {extendTheme, type ThemeConfig} from "@chakra-ui/react";

const config: ThemeConfig = {
    initialColorMode: "dark",
    useSystemColorMode: false,
};

const theme = extendTheme({
    config,
    colors: {
        brand: {
            50: "#E6F7FF",
            100: "#BDEBFF",
            200: "#8AD8FF",
            300: "#57C5FF",
            400: "#2FB3FF",
            500: "#0E9BFF",
            600: "#0A7BD1",
            700: "#075CA3",
            800: "#043D75",
            900: "#02244A",
        },
        neon: {
            500: "#B84CFF",
        },
    },
    semanticTokens: {
        colors: {
            "app.bg": {
                default: "gray.50",
                _dark: "#070A10",
            },
            "app.surface": {
                default: "white",
                _dark: "#0C1220",
            },
            "app.surface2": {
                default: "gray.50",
                _dark: "#0A0F1B",
            },
            "app.border": {
                default: "gray.200",
                _dark: "whiteAlpha.200",
            },
            "app.textMuted": {
                default: "gray.600",
                _dark: "whiteAlpha.700",
            },
            "app.glow": {
                default: "brand.500",
                _dark: "brand.400",
            },
        },
    },
    styles: {
        global: {
            body: {
                bg: "app.bg",
                color: "gray.800",
                _dark: {color: "whiteAlpha.900"},
            },
        },
    },
    components: {
        Button: {
            defaultProps: {colorScheme: "brand"},
            baseStyle: {borderRadius: "lg"},
        },
        IconButton: {
            baseStyle: {borderRadius: "lg"},
        },
        Card: {
            baseStyle: {
                container: {
                    borderRadius: "xl",
                    borderWidth: "1px",
                    borderColor: "app.border",
                    bg: "app.surface",
                },
            },
        },
        Input: {
            baseStyle: {
                field: {borderRadius: "lg"},
            },
        },
        Textarea: {
            baseStyle: {
                borderRadius: "lg",
            },
        },
        Badge: {
            baseStyle: {borderRadius: "md"},
        },
    },
});

export default theme;